const modal = innerWidth => {
  // const WINDOW_WIDTH = window.innerWidth;
  const arrModalContents = [{
      img: 'win1.png',
      imgSp: 'win1-sp.png',
      alt: '長期熟成した旨みあふれる〝生みそ〟。 三年以上長期熟成させた旨みあふれる味噌を「非加熱製法」でお届けします。生みそだから味噌本来の味、風味が活きています。'
    },
    {
      img: 'win2.png',
      imgSp: 'win2-sp.png',
      alt: 'かつお節の〝削りたて〟のおいしさを。 かつお節を別添にすることで、削りたての味と香りを保ちます。仕上げに加えることで、みそ汁の味わいをさらに高めます。'
    },
    {
      img: 'win3.png',
      imgSp: 'win3-sp.png',
      alt: '〝自然の恵み〟そのままに、うま味調味料一切不使用。  使ったのは味噌、 かつおぶし、 具※ だけ。〝 自然の恵み〟 だけで、 みそ汁はここまでおいしくなります。※ 品質保持のため、 醸造アルコールと食塩を使用しています。 '
    },
    {
      img: 'win4.png',
      imgSp: 'win4-sp.png',
      alt: '蔵出し信州こうじみそ 年に一回の大寒仕込みを経て、三年以上じっくり熟成させた天然醸造味噌。大豆は国産のトヨハルカ、米は国産のコシヒカリを使用。芳醇な香りと力強い旨み、ほのかな甘みが特長です。'
    },
    {
      img: 'win5.png',
      imgSp: 'win5-sp.png',
      alt: '蔵出し熟成赤みそ 職人たちが手間暇かけて仕込んだ味噌を、三年以上じっくり熟成。長期熟成ならではの深い旨みと、その中にかすかに感じる渋味や苦味がたまらない、通好みな味わいの味噌です。'
    },
  ];

  const arrModalToggles = document.querySelectorAll('.js-has-modal');
  const modal = document.querySelector('.modal');
  const modalImage = document.querySelector('.js-modal-image');

  if (arrModalToggles) {
    arrModalToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        let modalIndex = toggle.getAttribute('data-modal-index');

        modalImage.src = innerWidth >= 768 ? `img/${arrModalContents[modalIndex].img}` : `img/${arrModalContents[modalIndex].imgSp}`;
        modalImage.alt = arrModalContents[modalIndex].alt;

        modal.classList.add('toggled');
      });
    });
    
    modal.addEventListener('click', (e) => {
      if (e.target.classList.contains('modal') || e.target.classList.contains('modal__close')) {
        modal.classList.remove('toggled');
      }
    });
  }
}

export default modal;